import { Clock, RotateCcw } from "lucide-react";

const STEPS = [
  ["next", "Prochain rappel"],
  ["plus15", "+15 min"],
  ["plus60", "+1 h"],
  ["tomorrow", "Demain 16 h"],
  ["saturday", "Samedi midi"],
  ["monday", "Lundi 8 h"],
];

/** Simulator only: move time forward to see simulated SMS, the Saturday email and the Monday review. */
export const SimClockPanel = ({ now, smsToday, onAdvance, onReset }) => (
  <div className="rounded-2xl border border-gray-100 bg-white p-4" data-testid="sim-clock-panel">
    <div className="flex items-center justify-between">
      <div>
        <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#189346]">Horloge simulée</div>
        <div className="font-display text-lg font-bold" data-testid="sim-clock-now">
          {now.toLocaleString("fr-CA", { weekday: "long", day: "numeric", month: "long", hour: "2-digit", minute: "2-digit" })}
        </div>
      </div>
      <button type="button" onClick={onReset} className="rounded-full p-2 text-[#829C8D] hover:bg-gray-100" aria-label="Revenir à maintenant" data-testid="sim-clock-reset">
        <RotateCcw className="h-4 w-4" />
      </button>
    </div>
    <div className="mt-3 flex flex-wrap gap-1.5">
      {STEPS.map(([id, label]) => (
        <button key={id} type="button" onClick={() => onAdvance(id)} className="rounded-full border border-gray-200 px-3 py-1.5 text-xs font-semibold text-[#2d5a3d] hover:bg-[#F3FCF7]" data-testid={`sim-clock-${id}`}>
          <Clock className="mr-1 inline h-3 w-3" />
          {label}
        </button>
      ))}
    </div>
    <p className="mt-2 text-[11px] text-[#829C8D]" data-testid="sim-clock-sms-count">
      SMS simulés aujourd’hui : {smsToday} · une tâche = 3 rappels au plus (heure prévue, +1 h, +3 h) · aucun vrai SMS n’est envoyé (lot 4 en attente).
    </p>
  </div>
);

export default SimClockPanel;
